import { arrayOf, instanceOf, number, objectOf, oneOfType, shape, string, bool } from 'prop-types';

export const ProjectedItemsPropTypes = objectOf(
  shape({
    Assets: shape({
      AssetsBalance: string,
      AssetsInvestmentEarnings: string,
      AssetsContributions: string,
      AssetsDistributions: string,
      AssetGroups: arrayOf(
        shape({
          AssetGroup: string,
          AssetGroupBalance: string,
          AssetGroupInvestmentEarnings: string,
          AssetGroupContributions: string,
          AssetGroupDistributions: string,
          AssetGroupShortTermCapitalGainsTax: string, // same as InvestmentIncomeTax
          AssetGroupLongTermCapitalGainsTax: string, // same as CapitalGainsTax
          AssetGroupCostBasis: string,
          AssetDetails: arrayOf(
            shape({
              Owner: string,
              Name: string,
              Balance: oneOfType([string, instanceOf(null)]),
              InvestmentEarnings: oneOfType([string, instanceOf(null)]),
              Contributions: oneOfType([string, instanceOf(null)]),
              EmployerMatches: oneOfType([string, instanceOf(null)]),
              Distributions: oneOfType([string, instanceOf(null)]),
              InvestmentIncomeTax: oneOfType([string, instanceOf(null)]),
              CapitalGainsTax: oneOfType([string, instanceOf(null)]),
              CostBasis: oneOfType([string, instanceOf(null)]),
              CashInterestTax: oneOfType([string, instanceOf(null)]),
            }),
          ),
        }),
      ),
    }),
    Liabilities: shape({
      LiabilitiesBalance: string,
      LiabilityPayment: string,
      LiabilityInterest: string,
      LiabilityGroups: arrayOf(
        shape({
          LiabilityGroup: string,
          LiabilityGroupBalance: string,
          LiabilityGroupPayment: string,
          LiabilityGroupInterest: string,
          LiabilityDetails: arrayOf(
            shape({
              Id: string,
              Owner: string,
              Name: string,
              Balance: string,
              Payment: string,
              Interest: string,
            }),
          ),
        }),
      ),
    }),
    Networth: number,
  }),
);

export const PeriodsPropTypes = arrayOf(
  shape({
    Text: string,
    IsToggleable: bool,
    IsMonth: bool,
  }),
);
